import PropTypes from "prop-types";

export const ListDeleteIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    fill="none"
    viewBox="0 0 19 19"
    {...props}>
    <path
      stroke="#AFAFAF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
      d="M16.375 5.461a76.276 76.276 0 00-7.515-.375c-1.485 0-2.97.075-4.455.225l-1.53.15M7 4.704l.165-.982c.12-.713.21-1.245 1.478-1.245h1.964c1.268 0 1.366.562 1.478 1.252l.165.975M14.762 7.832l-.487 7.552c-.083 1.177-.15 2.093-2.243 2.093H7.217c-2.092 0-2.16-.916-2.242-2.093l-.488-7.552M8.372 13.352h2.498M7.75 10.352h3.75"></path>
  </svg>
);

ListDeleteIcon.propTypes = {
  active: PropTypes.string
};
